/* eslint-disable */
import debounce from 'lodash/debounce';

App.namespace.wrap('views.venue.location_venue_page', function () {
  const venueData = window.venuepageData;
  var latitude = venueData.latitude,
      longitude = venueData.longitude;

  var isMobile = window.matchMedia('(max-width: 767.98px)').matches;
  var venueLatLng = new google.maps.LatLng(
    latitude,
    longitude
  ),
  map_options = {
    mapId: '179e566d0aeca7f7',
    zoom: 14,
    center: venueLatLng,
    disableDefaultUI: true,
    scrollwheel: false,
    panControl: true,
    scaleControl: false,
    zoomControl: isMobile ? false : true,
    zoomControlOptions: {
          style: google.maps.ZoomControlStyle.LARGE,
          position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
    streetViewControl: true,
    streetViewControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM
    },
    /* eslint-disable */
    styles: [
      { 'featureType': 'poi.business', 'elementType': 'labels', 'stylers': [{ 'visibility': 'off' }] },
      { 'featureType': 'poi.business', 'elementType': 'labels', 'stylers': [{ 'visibility': 'off' }] },
      { 'featureType': 'poi.medical', 'elementType': 'labels', 'stylers': [{ 'visibility': 'off' }] },
      { 'featureType': 'poi.sports_complex', 'elementType': 'labels', 'stylers': [{ 'visibility': 'off' }] },
      { 'featureType': 'poi.attraction', 'elementType': 'all', 'stylers': [{ 'visibility': 'off' }] },
    ],
    /* eslint-enable */
    };

  const mapCanvas = document.getElementById('map-canvas');
  const map = new window.google.maps.Map(mapCanvas, map_options);

  // Add special marker for current venue
  const venuePin = document.createElement('div');
  venuePin.id = 'venuePin';
  venuePin.innerHTML = `
    <div class="rounded-md bg-green">
      <div class="flex gap-2 p-3 items-center text-white font-semibold text-md">
        <div class="infowindow-venue-icon min-w-6 w-6 h-6"></div>
        <div>${venueData.venueName}</div>
      </div>
    </div>
  `;
  const popup = App.views.google_map_popup(venueLatLng, venuePin);
  popup.setMap(map);

  function addMarkersForRecommendedRoomCards() {
    venueData.recommendedRoomCards?.forEach((card) => {
      const distanceFromVenue = Math.sqrt(
        (card.position.latitude - latitude) ** 2 +
        (card.position.longitude - longitude) ** 2,
      );
      if (distanceFromVenue < 0.015) {
        return;
      }

      const cardLatLng = new window.google.maps.LatLng(card.position.latitude, card.position.longitude);
      const markerImg = document.createElement('img');
      markerImg.src = '/img/icons/pin-red.svg';
      markerImg.alt = '';
      const marker = new window.google.maps.marker.AdvancedMarkerElement({
        position: cardLatLng,
        map,
        content: markerImg,
        draggable: false,
        title: card.room_name === card.venue_name ? card.venue_name : `${card.room_name} at ${card.venue_name}`,
      });

      marker.addListener('click', () => {
        App.track.event('venue_page_interaction', {
          section: 'map',
          element: 'pin',
          interaction: 'click',
        });
        window.open(card.room_url, '_blank').focus();
      });
    });
  }

  if (window.__TGV_IS_RWG_SESSION) {
    document.querySelector('.js-venue-location-headline').innerText = 'Explore the area';
  } else {
    addMarkersForRecommendedRoomCards();
  }

  let zoom = map.getZoom();
  window.google.maps.event.addListener(map, 'zoom_changed', () => {
    const newZoom = map.getZoom();
    let interaction = 'zoom_in';
    if (newZoom < zoom) {
      interaction = 'zoom_out';
    }

    App.track.event('venue_page_interaction', {
      section: 'location',
      element: 'map',
      interaction,
    });

    zoom = newZoom;
  });

  window.google.maps.event.addListener(map, 'center_changed', debounce(() => {
    App.track.event('venue_page_interaction', {
      section: 'location',
      element: 'map',
      interaction: 'move',
    });
  }, 1000, false));

  const thePanorama = map.getStreetView();
  window.google.maps.event.addListener(thePanorama, 'visible_changed', () => {
    if (thePanorama.getVisible()) {
      App.track.event('venue_page_interaction', {
        section: 'location',
        element: 'map',
        interaction: 'street_view',
      });
    }
  });

  $('#map-canvas').onIntersection(() => {
    App.track.event('venue_page_interaction', {
      section: 'map',
      element: null,
      interaction: 'visible',
    });
  });
});
